import React from 'react';
import PropTypes from 'prop-types';
import { isNumber } from '@cyberint/common-utils';
import { LoadingSpinner } from '@cyberint/dsc';
import * as S from './styled';

const renderCount = count => (isNumber(count) ? Number(count || 0).toLocaleString() : count);

export const TabTitle = ({ title, count = 0, total, isLoading }) => (
  <S.TabTitle>
    {title}
    {isLoading ? (
      <LoadingSpinner color="var(--darkSlateGray3)" size={16} />
    ) : (
      ` (${renderCount(count)}${total ? ` / ${renderCount(total)}` : ''})`
    )}
  </S.TabTitle>
);

TabTitle.propTypes = {
  title: PropTypes.node,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool
};
